import PropTypes from 'prop-types';
import { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AutocompleteType, TravelTypes } from '../../../../../constants';
import carSearchInput from '../../../../../helpers/selectors/carSearchInput';
import { autocompleteRequest } from '../../../../../store/slices/autocomplete';
import { setCarTripSearchInputs } from '../../../../../store/slices/tripSearch';
import SingleSelectAutocompleteFilter from '../../../../Filters/SingleSelectAutocompleteFilter';

const CarFlightOrigin = ({ tripId, selectedTab, bgClassName }) => {
  const dispatch = useDispatch();
  const isTripSearch = !tripId;
  const { flightOriginAutocompleteResults } = useSelector((store) => store.autocomplete);
  const { searchInputs } = useSelector(carSearchInput(tripId, selectedTab, isTripSearch));
  const [flightOriginLabel, setFlightOriginLabel] = useState('Flight origin');
  const { travelAgency } = useSelector((store) => store.user);

  const handleFilterChange = useCallback(
    (field) => (value) => {
      if (isTripSearch) {
        dispatch(
          setCarTripSearchInputs({
            tripId,
            [field]: value,
          }),
        );
      }
    },
    [dispatch, isTripSearch, tripId],
  );

  const handleAutocompleteChange = useCallback(
    (autocompleteTypes, responseType) => (query) => {
      dispatch(autocompleteRequest({ autocompleteTypes, responseType, query }));
    },
    [dispatch],
  );

  useEffect(() => {
    if (
      travelAgency &&
      travelAgency.filterSettings &&
      travelAgency.filterSettings.flightOriginLabel
    ) {
      setFlightOriginLabel(travelAgency.filterSettings.flightOriginLabel);
    }
  }, [travelAgency]);

  return (!travelAgency ||
    !travelAgency.tripkitEnabledTransportModes ||
    travelAgency.tripkitEnabledTransportModes.indexOf(TravelTypes.flight) > -1) &&
    isTripSearch ? (
    <SingleSelectAutocompleteFilter
      onChange={handleFilterChange('origin')}
      options={flightOriginAutocompleteResults}
      onInputChange={handleAutocompleteChange(
        AutocompleteType.FLIGHT_ORIGIN,
        'flightOriginAutocompleteResults',
      )}
      value={searchInputs.origin}
      label={flightOriginLabel}
      filterButtonMaxWidth="max-w-filter"
      widthInside="max-w-85"
      bgClassName={bgClassName}
    />
  ) : (
    <></>
  );
};

CarFlightOrigin.propTypes = {
  tripId: PropTypes.string,
  selectedTab: PropTypes.number,
  bgClassName: PropTypes.string,
};

CarFlightOrigin.defaultProps = {
  tripId: undefined,
  selectedTab: 0,
  bgClassName: undefined,
};

export default CarFlightOrigin;
